<template>
  <modal-small class="support-modal" :closeBtn="true" @close="close">
    <template v-slot:header>We're here to help</template>
    <template v-slot:postheader>Our concierge team is available by:</template>
    <div>
      <div class="container-content">
        <section id="email">
          <div class="row">
            <div class="col-2" id="c1">
              <span aria-hidden="true" title="Email" class="fa-layers fa-fw">
                <font-awesome-layers>
                  <font-awesome-icon icon="fa-regular fa-circle" class="circle" size="10x" />
                  <font-awesome-icon
                    icon="fa-solid fa-envelope"
                    class="icon"
                    transform="shrink-6"
                  />
                </font-awesome-layers>
              </span>
            </div>
            <div class="col-9" id="c2">
              <div class="row" id="c2r1">
                <h2 class="subheader" id="c2r1">Email</h2>
              </div>
              <div class="row" id="c2r2">
                <a class="email-link" :href="`mailto:${emailAddress}`">{{ emailAddress }}</a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="container-content">
        <section id="phone">
          <div class="row">
            <div class="col-2" id="c1">
              <div class="icon-wrapper">
                <span aria-hidden="true" title="Phone" class="fa-layers fa-fw">
                  <font-awesome-layers>
                    <font-awesome-icon icon="fa-regular fa-circle" class="circle" size="10x" />
                    <font-awesome-icon icon="fa-solid fa-phone" class="icon" transform="shrink-7" />
                  </font-awesome-layers>
                </span>
              </div>
            </div>
            <div class="col-9" id="c2">
              <div class="row" id="c2r1">
                <h2 class="subheader">Phone</h2>
              </div>
              <div class="row" id="c2r2">
                <a class="phone" :href="`tel:${hrefTFN}`">{{ tollFreeNumber }}</a>
              </div>
              <div class="row" id="c2r3">
                <span class="textAlignLeft"
                  >Agents are available by phone 24 hours a day, 7 days a week.</span
                >
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </modal-small>
</template>

<script setup lang="ts">
import ModalSmall from "@/components/shared/ModalSmall.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import useApplicationData from "@/composables/useApplicationData";
import { useStore } from "vuex";

useStore();

const { tollFreeNumber, hrefTFN, emailAddress } = useApplicationData();

const emit = defineEmits(["close"]);

function close(event: any) {
  emit("close", event);
}
</script>

<style lang="scss" scoped>
.support-modal {
  .circle {
    color: var(--theme-color);
    background-color: white;
    font-size: 60px;
  }

  .icon {
    color: var(--theme-color);
    font-size: 60px;
  }
}

.container-content {
  font-size: 1.2em;
  padding: 1.563rem 1.5rem;
  margin: 0;

  .row {
    display: flex;
    align-items: center;
    color: #383838;
  }
}

/* Style phone number and email*/
.email-link,
.phone {
  color: #383838;
  text-decoration: underline;
}

section {
  margin-bottom: 40px;
}

section:last-child {
  margin-bottom: 0px;
}

/* Style */
.col-2,
.col-8,
.col-10 {
  padding: 0;
}

/* Style header */
h2.subheader {
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.cuscd-full-wrap .row {
  margin: 0;
}

.col-2 {
  -ms-flex: 0 0 12.666667%;
  flex: 1 0 12.666667%;
  max-width: 12.666667%;
  margin-right: 1em;
}

/* Small and Medium devices (phones, tablets, 992px and down) */
@media (max-width: 992px) {
  .support-modal {
    .col-2 {
      -ms-flex: 1 0 10.666667%;
      flex: 1 0 10.666667%;
      max-width: 10.666667%;
    }

    .circle {
      font-size: 50px;
    }

    .icon {
      font-size: 50px;
    }

    #c2r2.row,
    #c2r1.row,
    span {
      text-align: left;
    }

    .container-content {
      flex-wrap: wrap;
      font-size: 1.2em;
    }

    .container-content .row {
      padding: 0;
      align-items: baseline;
    }
  }
}

.textAlignLeft {
  text-align: left;
}

/* small devices */
@media (max-width: 600px) {
  .support-modal .col-2 {
    -ms-flex: 0 0 13.666667%;
    flex: 0 0 13.666667%;
    max-width: 13.666667%;
  }
}

/* Extra extra small devices */
@media (max-width: 300px) {
  .support-modal {
    // hides icons when screen size extra small
    .circle {
      display: none;
    }

    .icon {
      display: none;
    }

    #c1 {
      width: 0%;
      display: none;
    }

    .container-content .row {
      padding: 0;
      align-items: baseline;
    }

    #c2r2.row,
    #c2r1.row,
    span {
      text-align: left;
    }
  }
}
</style>
